<template>
    <ur-box :title="title" :toggleable="toggleable" :class="'ur-search-box-wrapper ur-search-box-wrapper--'+$_size">
        <template v-slot:title-zone>
            <!--
            $ver: v0.1.0
            <em>ur-box</em>와 동일하게 title-zone을 사용할 수 있습니다.
            자세한 내용은 <em>ur-box</em>를 참고하시길 바랍니다.
            #You can use title-zone just like <em> ur-box </em>.
            #Please see <em> ur-box </em> for more information.
            -->
            <slot name="title-zone"/>
        </template>
        <div class="ur-search-box" :class="searchBoxClass" @click="onClick">
            <div class="ur-search-box__contents">
                <!--
                $ver: v0.1.0
                <em>ur-search-row</em>, <em>ur-search-item</em>등이 들어올 수 있는 default slot입니다.
                &lt;hr>태그도 사용할 수 있습니다.
                #This is the default slot for <em> ur-search-row </em>, <em> ur-search-item </em>, etc.
                -->
                <slot/>
                <hr v-if="isExpanded"/>
                <div v-show="isExpanded" class="ur-search-box__contents">
                    <!--
                    $ver: v0.1.2
                    In addition to the content that should be shown as required, you can fold and expand the optional elements separately.
                    #
                    -->
                    <slot name="expandable-zone"/>
                </div>
                <div v-if="$scopedSlots['bottom-action-bar']"
                     :class="'ur-search-box__action-grp ur-search-box__action-grp--bottom ur-search-box__action-grp--'+$_size">
                    <!--
                    $ver: v0.1.1
                    이 slot에는 <em>ur-action-bar</em>를 활용해야 정상적으로 사용할 수 있습니다.
                    action button들을 <em>ur-search-box</em>내부 하단영역에 위치시킵니다.
                    #This slot requires <em> ur-action-bar </em> for normal use.
                    #Place the action buttons inside the <em> ur-searcb-box </em> bottom area.
                    -->
                    <slot name="bottom-action-bar"></slot>
                </div>
            </div>
            <div v-if="$scopedSlots['right-action-bar']"
                 :class="'ur-search-box__action-grp ur-search-box__action-grp--right ur-search-box__action-grp--'+$_size">
                <ur-search-item no-label>
                    <!--
                    $ver: v0.1.1
                    이 slot에는 <em>ur-action-bar</em>를 활용해야 정상적으로 사용할 수 있습니다.
                    action button들을 <em>ur-search-box</em>내부 우측영역에 위치시킵니다.
                    여러 row를 사용한다면 마지막 row의 우측에 위치하게됩니다.
                    #This slot requires <em> ur-action-bar </em> for normal use.
                    #Place the action buttons inside the <em> ur-search-box </em> right area.
                    #If you use multiple rows, they will be located to the right of the last row.
                    -->
                    <slot name="right-action-bar"/>
                </ur-search-item>
            </div>

            <!-- 확장영역 라인부분 -->
            <div v-if="$scopedSlots['expandable-zone']" class="ur-search-box__exp-bottom">
                <div class="ur-search-box__exp-bottom__line"></div>
                <div class="ur-search-box__exp-bottom__toggle" @click="expandToggle">
                    <ur-icon-wrapper>
                        <ur-icon :icon="expandIcon"/>
                    </ur-icon-wrapper>
                    {{expandMessage}}
                </div>
                <div class="ur-search-box__exp-bottom__line"></div>
            </div>
        </div>
        <div v-if="!noSearchButton && (!$scopedSlots['right-action-bar'] && !$scopedSlots['bottom-action-bar'])"
             :class="'ur-search-box__action-grp ur-search-box__action-grp--outer ur-search-box__action-grp--'+$_size">
            <slot name="outer-action-bar">
                <ur-action-bar>
                    <ur-button main @click="searchAction">{{searchLabel}}</ur-button>
                </ur-action-bar>
            </slot>
        </div>
    </ur-box>
</template>

<script>
    const TAG_ITEM = "urFormItem";
    //ur-search-box는 검색 영역을 표시하기 위한 컴포넌트입니다. 검색버튼과 관련 이벤트가 제공됩니다.
    //#ur-search-box is a component to build search condition. It provide the search button and related event.
    export default {
        name: "urSearchBox",
        props: {
            // $ver: v0.1.0
            // $default: 2
            // <em>ur-search-box</em>안쪽으로 column을 몇개로 나누어 관리할지 설정합니다.
            // props자체에 기본값은 없지만 data영역에 기본값이 2로 정의되어있습니다.
            // #Sets how many columns to manage inside <em> ur-search-box </em>.
            // #There is no default value for props itself, but the default value is defined as 2 in the data area.
            column     : [String, Number],
            // $ver: v0.1.0
            // $abbr: column
            col        : [String, Number], /* abbr */
            // $ver: v0.1.0
            // <em>ur-search-box</em>안쪽에서 쓰이는 <em>ur-search-item</em>각각이 가지는 label-size를 설정합니다.
            // <em>ur-search-item</em>에서 label-size가 따로 설정된다면 그 값을 우선합니다.
            // #Set the label-size that each <em> ur-search-item </em> used inside of <em> ur-search-box </em>.
            // #If label-size is set separately in <le> ur-search-item </em>, it takes precedence.
            labelSize  : String,
            // $ver: v0.1.0
            // $default: inline
            // 'inline' 혹은 'block'의 값을 줄 수 있으며 기본값은 'inline'입니다.
            // label과 content가 inline으로 왼쪽-오른쪽에 위치할지 block형태로 아래-위로 위치할지 선택합니다.
            // #You can give the value 'inline' or 'block', and the default is 'inline'.
            // #Choose whether the label and content are left-right inline or down-up in block form.
            labelDisplay : {
                type:String,
                validator: (val) => {
                    let lowerVal = val.toLowerCase();
                    return ['inline', 'block'].indexOf(lowerVal) !== -1;
                }
            },
            // $ver: v0.1.0
            // $default: left
            // 'left' 혹은 'right'의 값을 줄 수 있으며 기본값은 'left'입니다.
            // <em>ur-search-item</em>의 label영역 안에서 좌-우 정렬을 선택할 수 있습니다.
            // #You can give a value of 'left' or 'right'. The default value is 'left'.
            // #You can select left-right alignment within the label area of ​​<em> ur-search-item </em>.
            labelAlign : {
                type:String,
                validator: (val) => {
                    let lowerVal = val.toLowerCase();
                    return ['left', 'right'].indexOf(lowerVal) !== -1;
                }
            },
            // $ver: v0.1.0
            // <em>ur-search-item</em>의 toggle slot을 사용하는 경우 default slot을 보여줄지 toggle slot을 보여줄 지
            // 선택할 수 있습니다. 주로 수정요건이 필요한경우 사용합니다.
            // #If you use toggle slot of <em> ur-search-item </em>, you can choose whether to show default slot or toggle slot.
            // #It is mainly used when modification requirements are needed.
            toggle     : Boolean,
            // $ver: v0.1.2
            // expandable-zone slot을 사용하는 경우 해당 slot의 content를 보여줄지 여부를 선택할 수 있습니다.
            // 주로 첫 접근시 초기값으로 펼쳐져있을지 접혀져있을지 여부를 컨트롤 하기 위해 사용됩니다.
            // expandable-zone을 펼치고 접는 아이콘이 따로 있어 펼쳐짐 여부는 컴포넌트 내부에서 관리되기 때문에
            // 따로 props설정은 필요없지만, 펼쳐짐 여부에 따라 외부에서 동작이 달라져야할 경우
            // :expanded.sync="variable"의 형태로 2way-binding을 사용할 수 있습니다.
            // #If you use an expandable-zone slot, you can choose whether to show the contents of that slot.
            // #This is used to control whether it is expanded or collapsed to its initial value on first access.
            // #There is a separate expandable-zone icon for expanding and collapsing.
            // #You don't need to configure props, but you can use 2way-binding in the form of
            // # :expanded.sync = "variable" if you need to change the behavior externally depending on whether it is expanded.
            expanded: {
                type:Boolean,
                default: false
            },
            // $ver: v0.1.2
            // expandable-zone slot을 사용하는 경우 펼치고 접는 부분을 컨트롤 하기 위한 아이콘 옆에
            // 문자열 형태로 메시지를 할당해줄 수 있습니다.
            // 펼치다, 접다 등 상황에 따라 다른 메시지를 보여줘야 한다면 expanded props값에 따라 expandMessage 또한
            // 달라져야 할 것입니다.
            // #If you use an expandable-zone slot, you can assign a message in the form of a string next to the icon to control the expansion and collapse.
            // #If you need to display different messages in different situations, such as expand or collapse, expandMessage will also need to change depending on the value of the expanded props.
            expandMessage: {
                type: String,
                default: ''
            },
            // $ver: v0.1.2
            // 검색 버튼의 라벨 입니다.
            // #A value is for search button's label
            searchLabel: {
                type: String,
                default: 'Search'
            },
            // $ver: v0.1.2
            // 검색 버튼의 라벨 입니다.
            // #A value is for search button's label
            noSearchButton: {
                type: Boolean,
                default: false
            },

            /*[PROP] for UR-BOX*/
            // $ver: v0.1.0
            // <em>ur-box</em>와 마찬가지로 필요하다면 title을 활용할 수 있습니다.
            // #As with <em> ur-box </em>, you can use title if you need to.
            title      : String,
            // $ver: v0.1.0
            // <em>ur-box</em>와 마찬가지로 필요하다면 <em>ur-search-box</em>영역 전체를 접었다 펼칠 수 있습니다.
            // #As with <em> ur-box </em>, you can collapse and expand the entire <em> ur-search-box </em> area if necessary.
            toggleable : Boolean,

            // $ver: v0.1.0
            // <em>ur-search-box</em> 전체적으로 small크기를 사용합니다.
            // <em>ur-search-item</em> 및 그 아래쪽에 속한 <em>ur-input</em>계열 모든 컴포넌트 크기에 영향을 줍니다.
            // 해당 컴포넌트들이 각각의 크기설정을 가진 경우 그 값을 우선으로 합니다.
            // #<em> ur-search-box </em> Use small size throughout.
            // #Affects the size of all <em> ur-search-item </em> and the <em> ur-input </em> series below it.
            // #If each component has its own size setting, the value takes precedence.
            small      : Boolean,
            // $ver: v0.1.0
            // $abbr: small
            sm         : Boolean,
            // $ver: v0.1.0
            // <em>ur-search-box</em> 전체적으로 medium크기를 사용합니다.
            // 크기설정이 따로 없다면 medium을 기본값으로 하며, 기본값 설정은 data에 선언되어있습니다.
            // <em>ur-search-item</em> 및 그 아래쪽에 속한 <em>ur-input</em>계열 모든 컴포넌트 크기에 영향을 줍니다.
            // 해당 컴포넌트들이 각각의 크기설정을 가진 경우 그 값을 우선으로 합니다.
            // #<em> ur-search-box </em> Use medium size throughout.
            // #If no size is specified, medium is the default and the default is declared in data.
            // #Affects the size of all <em> ur-search-item </em> and the <em> ur-input </em> series below it.
            // #If each component has its own size setting, the value takes precedence.
            medium     : Boolean,
            // $ver: v0.1.0
            // $abbr: medium
            md         : Boolean,
        },
        data() {return {
            default: {
                labelDisplay: 'inline',
                labelAlign: 'left',
                size: 'medium',
                column: 2
            },
            isExpanded: false
        }},
        computed : {
            $_col() {return parseInt(this.column) || parseInt(this.col)  || this.default.column;},
            $_size() {
                if(this.small || this.sm) {return 'small';}
                if(this.medium || this.md) {return 'medium';}
                return this.default.size;
            },
            searchBoxClass() {
                let rtn = [];
                if(!!this.$scopedSlots['expandable-zone']) rtn.push('ur-search-box--expandable');
                rtn.push('ur-search-box--'+this.$_size);
                return rtn;
            },
            expandIcon() {
                return this.isExpanded ? 'collapse_menu': 'expand_menu';
            },
            sharedData() {
                let rtn = {}, odf = Object.defineProperty;
                odf(rtn, "col"         , {get:()=>this.$_col});
                odf(rtn, "labelSize"   , {get:()=>this.labelSize});
                odf(rtn, "labelDisplay", {get:()=>this.labelDisplay||this.default.labelDisplay});
                odf(rtn, "labelAlign"  , {get:()=>this.labelAlign||this.default.labelAlign});
                odf(rtn, "toggle"      , {get:()=>this.toggle});
                odf(rtn, "size"        , {get:()=>this.$_size});
                return rtn;
            }
        },
        watch: {
            expanded:{
                immediate: true,
                handler(val) {
                    if (val !== this.isExpanded) {
                        this.isExpanded = val;
                    }
                }
            }
        },
        methods: {
            onClick() {
                this.$emit('click');
            },
            expandToggle() {
                this.isExpanded = !this.isExpanded;
                this.$emit('update:expanded', this.isExpanded);
                this.$emit('expandToggle', this.isExpanded);
            },
            searchAction() {
                this.$emit('search');
            }
        },
        provide(){
            return {boxInfo:this.sharedData};
        }
    }



</script>
